<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="PUBLIC FILES LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:action="{ tableRow }">
        <el-popconfirm
          title="Confirm to delete？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleRemove(tableRow.row.id)"
        >
          <a
            href="javascript:void(0)"
            class="icon-trash1"
            style="color: #3a3f63"
            slot="reference"
          />
        </el-popconfirm>
      </template>
      <template v-slot:files="{ tableRow }">
        <el-popover placement="top" trigger="click">
          <div
            style="text-align: center"
            v-for="item in tableRow.row.files"
            :key="item.id"
          >
            <a href="javascript:void (0)" @click="handleDownload(item.id)">
              {{ item.name }}
            </a>
          </div>
          <span v-if="tableRow.row.files == ''"></span>
          <el-button type="text" slot="reference" v-else>Check</el-button>
        </el-popover>
      </template>
    </table-view>

    <!-- 新增弹窗   -->
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="462px"
      @close="handleCancel"
      :close-on-click-modal="false"
    >
      <el-card shadow="never">
        <el-form :model="form" ref="form" label-position="top" :rules="rules">
          <el-form-item label="Document Type" prop="type">
            <el-select v-model="form.type" style="width: 100%">
              <el-option
                v-for="item in fileTypeList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Document Name" prop="name">
            <el-input style="width: 100%" v-model="form.name" />
          </el-form-item>
          <el-form-item label="Remark" prop="remark">
            <el-input style="width: 100%" v-model="form.remark" />
          </el-form-item>
          <el-upload
            ref="upload"
            :action="uploadUrl"
            :headers="{ Authorization: $store.state.token }"
            :data="form"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleChange"
            :file-list="fileList"
            :limit="5"
            :on-exceed="handleBeyond"
          >
            <customize-button style="width: 100%">
              Upload Documents
            </customize-button>
          </el-upload>
          <ul class="upload-list">
            <li class="item" v-for="(item, index) in fileList" :key="item.uid">
              <p :title="item.name">{{ item.name }}</p>
              <a href="javascript:void (0)" @click="handleRemoveItem(index)">
                Delete
              </a>
            </li>
          </ul>
        </el-form>
      </el-card>
      <template slot="footer">
        <customize-button
          class="clear-btn"
          style="margin-right: 20px"
          @click="handleCancel"
        >
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleSaveBtn">
          Save
        </customize-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getSelectList } from '@/api'
import { getTableData, add, remove, download } from './api'
import config from '@/config'

export default {
  data() {
    const searchModel = [
      {
        label: 'File name',
        type: 'input',
        key: 'name',
      },
      {
        label: 'Create Time',
        type: 'time',
        key: 'time',
      },
      {
        label: 'File Type',
        type: 'select',
        placeholder: 'All',
        key: 'type',
        selectList: [],
      },
    ]
    const tableModel = [
      {
        label: 'Document name',
        prop: 'name',
      },
      {
        label: 'Document Type',
        prop: 'fileType',
      },
      {
        label: 'Create Time',
        prop: 'createTime',
      },
      {
        label: 'Submitted By',
        prop: 'operator',
      },
      {
        label: 'Remark',
        prop: 'remark',
      },
      {
        label: 'Doc.',
        slotName: 'files',
      },
      {
        label: 'Action',
        width: 120,
        slotName: 'action',
      },
    ]
    return {
      uploadUrl: `${config.baseApi}/masterdata-api/document/upload`,
      searchModel: searchModel,
      tableModel: tableModel,
      tableData: [],
      pages: {},
      visible: false,
      form: {
        type: '',
        name: '',
        remark: '',
      },
      rules: {
        type: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        name: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
      },
      fileTypeList: [],
      fileList: [],
    }
  },
  mounted() {
    this.initTable()
    this._getSelectList()
  },
  methods: {
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    async _getSelectList() {
      try {
        this.fileTypeList = await getSelectList('DocType')
        this.searchModel[2].selectList = this.fileTypeList
      } catch (err) {
        console.error(err)
      }
    },
    handleCancel() {
      this.visible = false
      this.$refs.form.resetFields()
      this.fileList = []
    },
    async handleSaveBtn() {
      try {
        const valid = await this.$refs.form.validate()
        if (valid) {
          // todo 多文件上传
          const formData = new FormData()

          this.fileList.forEach(item => {
            formData.append('file', item.raw)
          })

          Object.keys(this.form).forEach(key => {
            formData.append(key, this.form[key])
          })

          try {
            await add(formData)
            this.$message.success('success')
            this.initTable()
            this.visible = false
          } catch (err) {
            console.error(err)
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    async handleTitleActionBtn() {
      this.visible = true
    },
    async handleRemove(id) {
      try {
        await remove(id)
        this.initTable()
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
    },
    handleChange(file) {
      if (file.response) return
      if (this.fileList.length < 5) {
        this.fileList.push(file)
      }
    },
    handleBeyond() {
      this.$message.warning('最多上传5个文件')
    },
    handleRemoveItem(index) {
      this.fileList.splice(index, 1)
    },
    async handleDownload(id) {
      try {
        await download(id)
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-list {
  width: 100%;
  margin-top: 20px;

  .item {
    display: flex;
    width: 100%;
    text-align: left;
    line-height: 30px;
    font-size: 16px;
    color: #3a3f63;

    p {
      width: 320px;
      @include no-wrap();
    }

    a {
      margin-left: 14px;
    }
  }
}
</style>
